import { Box, Typography } from "@mui/material";
import React, { useState } from "react";
import {
  a11yProps,
  MainTabPanel,
  StyledTab,
  StyledTabs,
} from "../Common/UI/TabPanel";
import ParticipantDetails from "./Tabs/ParticipantDetails";
import ParticipantStudies from "./Tabs/ParticipantStudies";
import { HeaderLeftContent, StyledHeader } from "../Common/styles/header";
import { useQuery } from "../../utils/hooks";

const GlobalParticipantTabs = () => {
  const [type, setType] = useState<string>("details");
  const participantName = useQuery().get("participant") || "";

  const handleChange = (_: any, newValue: string) => {
    setType(newValue);
  };

  return (
    <>
      <Box
        sx={{
          height: "60px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          p: "0px 24px",
          bgcolor: "#FFFFFF",
          borderBottom: "1px solid #E5E7EB",
        }}
      ></Box>
      <StyledHeader>
        <Box sx={HeaderLeftContent}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <Typography variant="subtitle1" fontWeight="medium">
              {participantName || ""}
            </Typography>
          </Box>
        </Box>
      </StyledHeader>

      <Box sx={{ borderTop: 1, borderBottom: 1, borderColor: "#E5E7EB" }}>
        <StyledTabs value={type} onChange={handleChange}>
          <StyledTab
            sx={{ display: "flex", gap: "10px", minHeight: "48px" }}
            label="Details"
            value="details"
            {...a11yProps(0)}
          />
          <StyledTab
            sx={{ display: "flex", gap: "10px", minHeight: "48px" }}
            label="Studies"
            value="studies"
            {...a11yProps(1)}
          />
        </StyledTabs>
      </Box>
      <Box
        sx={{
          height: "calc(100% - 182px)",
          overflow: "auto",
        }}
      >
        <MainTabPanel value={type} index={"details"}>
          <ParticipantDetails />
        </MainTabPanel>
        <MainTabPanel value={type} index={"studies"}>
          <ParticipantStudies />
        </MainTabPanel>
      </Box>
    </>
  );
};

export default GlobalParticipantTabs;
